module.exports = __webpack_public_path__ + "img/mine.781b90f6.png";